import { makeAutoObservable } from 'mobx';
import { xor } from 'lodash/fp';
import {
    HeatmapPercentile,
    HeatmapScoreType,
} from 'components/Heatmap/HeatmapTypes';
import { E_TIME_PRESET_KEYS } from '../constants';
import moment from 'moment';
import { E_RISK_TYPE } from 'interfaces';

export interface IHeatmapStore {
    countriesList: number[],
    title: string,
    scoreType: HeatmapScoreType,
    startDate: Date,
    timeSpan: E_TIME_PRESET_KEYS,
    riskType: E_RISK_TYPE,
    selectedRisk: number,
    selectedPercentile: HeatmapPercentile,
    selectedCountry: number,
}
export class HeatmapStore implements IHeatmapStore {
    constructor() {
        makeAutoObservable(this);
    }
    public countriesList: number[] = [];
    public title: string = '';
    public riskType: E_RISK_TYPE = E_RISK_TYPE.DIMENSIONS;
    public scoreType: HeatmapScoreType = HeatmapScoreType.PULSE;
    public startDate: Date = moment()
        .startOf('day')
        .toDate();
    public timeSpan: E_TIME_PRESET_KEYS =
        E_TIME_PRESET_KEYS.THREE_MONTHS;

    public selectedRisk: number = null;    
    public selectedCountry: number = null;    
    public selectedPercentile: HeatmapPercentile = null;

    setCountriesList(countriesList: number[]) {
        this.countriesList = [...countriesList];
    }

    public toggleCountry(countryId: number) {
        this.countriesList = xor([countryId], this.countriesList);
    }

    public removeCountry(countryId: number) {
        this.countriesList = this.countriesList.filter(
            cid => cid !== countryId
        );
    }

    public setRiskType(riskType: E_RISK_TYPE) {
        this.riskType = riskType;
    }

    public setScoreType(scoreType: HeatmapScoreType) {
        this.scoreType = scoreType;
    }

    public setSelectedRisk(selectedRisk: number) {
        this.selectedRisk = selectedRisk;
    }

    public setSelectedPercentile(percentile: HeatmapPercentile) {
        this.selectedPercentile = percentile;
    }

    public resetSelection() {
        this.selectedRisk = null;
        this.selectedCountry = null;
    }

    setTitle(title: string) {
        this.title = title;
    }

    setSelectedCountry(countryId: number) {
        this.selectedCountry = countryId;
    }

    setStartDate(date: Date) {
        this.startDate = date;
    }

    setTimeSpan(timespan: E_TIME_PRESET_KEYS) {
        this.timeSpan = timespan;
    }
}

export default new HeatmapStore();
